import { render } from "./AddToBundleOverlay.vue?vue&type=template&id=dac0af00"
import script from "./AddToBundleOverlay.vue?vue&type=script&lang=js"
export * from "./AddToBundleOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/bundle-builder/components/AddToBundleOverlay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dac0af00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dac0af00', __exports__)) {
    api.reload('dac0af00', __exports__)
  }
  
  module.hot.accept("./AddToBundleOverlay.vue?vue&type=template&id=dac0af00", () => {
    api.rerender('dac0af00', render)
  })

}


export default __exports__